export default class User {
	id: string;
	name: string;
	roles: Array<string>;
	phoneNumber: string;
	email: string;
	storeId: string;
	hasPassword: boolean;

	constructor() {
		this.name = "";
		this.roles = new Array<string>();
		this.phoneNumber = "";
		this.email = "";
		this.storeId = "";
	}
}
